export default {
  currentMenu({ commit, state }, path) {
    for (let k = 0; k < state.menuList.length; k += 1) {
      if (state.menuList[k].url === path) {
        commit('SET_CURRENT_MENU', state.menuList[k]);
        break;
      }
      if (state.menuList[k].children) {
        for (let j = 0; j < state.menuList[k].children.length; j += 1) {
          if (state.menuList[k].children[j].url === path) {
            commit('SET_CURRENT_MENU', state.menuList[k].children[j]);
            commit('SET_CURRENT_OPEN_MENU', state.menuList[k].url);
            break;
          }
        }
      }
    }
  },
  toggleSideNav(ctx) {
    ctx.commit('TOGGLE_SIDE_NAV');
  },
  currentProjectId(ctx, id) {
    ctx.commit('CURRENT_PROJECT_ID', id);
    window.localStorage.setItem('CURRENT_PROJECT_ID', id);
  },
  userInfo(ctx, id) {
    ctx.commit('USER_INFO', id);
  },
  authUrlList(ctx, playload) {
    ctx.commit('AUTH_URL_LIST', playload);
  },
  dictionary(ctx, playload) {
    ctx.commit('DICTIONARY', playload);
  },
};



// WEBPACK FOOTER //
// ./src/store/actions.js